import React from 'react';

import { Messages } from '../../codegen/Localize';
import { DeviceType } from '../../ts/models/DeviceType';
import { DeviceItem } from './DeviceItem';
import { DevicePreviewNavigationTools, DevicePreviewNavigationToolsProps } from './DevicePreviewNavigationTools';


export function DevicePickerBar(props: DevicePickerBar.Props):
    React.ReactElement<DevicePickerBar.Props> {
  const isSelected = (device: DeviceType): boolean => {
    return device === props.selectedDevice;
  };

  return (
    <div className="tab-preview-tools-container">
      <div className="tab-left-spacer" />
      <div className="tab-device-bar" role="tablist">
        <DeviceItem message={ Messages.desktop() } onDeviceTypeClick={ props.onDeviceTypeClick } isSelected={ isSelected('desktop') } device="desktop" />
        <DeviceItem message={ Messages.tablet() }onDeviceTypeClick={ props.onDeviceTypeClick } isSelected={ isSelected('tablet') } device="tablet" />
        <DeviceItem message={ Messages.phone() } onDeviceTypeClick={ props.onDeviceTypeClick } isSelected={ isSelected('phone') } device="phone" />
      </div>
      <div className="tab-right-spacer">
        <span className="tab-collapsible-margin" />
        <div className="tab-nav-tools">
          {props.navigationToolsProps === undefined ? null :
            <DevicePreviewNavigationTools
              {...props.navigationToolsProps}
            />
          }
        </div>
      </div>
    </div>
  );
}

export namespace DevicePickerBar {
  export interface Props {
    onDeviceTypeClick: (device: DeviceType) => void;
    selectedDevice: DeviceType;
    navigationToolsProps?: DevicePreviewNavigationToolsProps;
  }
}
